import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { MdDeleteOutline } from "react-icons/md";
import { RiPencilLine } from "react-icons/ri";
import { TbBulb } from "react-icons/tb";
import {  PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import PopupModal from "../PopupModal";
import FailureView from "../FailureView";
import LoadingView from "../LoadingView";
import SlidingModal from "../SlidingModal/slidingModal";
// import { ImProfile } from "react-icons/im";
// import ZoomInModal from "../ZoomModal";
import "./index.css";
import { ErrorText } from "../../StyledCss/styledComponents";
import { deleteUser } from "../../api/services/hroneApi";
import EditEmployeeModal from "../EditEmployeeModal";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const ActiveEmployeeTable = ({
  employeesList,
  apiStatus,
  refreshEmployeesList,
  leads
}) => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const canEdit = hasPermission(FEATURE_CODES.EMPLOYEE_EDIT);
  const canDelete = hasPermission(FEATURE_CODES.EMPLOYEE_DELETE);

  const handleRowClicked = (params) => {
    if (params.event.target.closest(".no-row-nav")) return;
    navigate(`/employee/${params.data.id}`, {
      state: { employee: params.data, leads, returnPath: "/allemployees" },
    });
  };

  const [singleEmployeeData, setSingleEmployeeData] = useState({});
  const [editEmployeeDetailsModal, setEditEmployeeDetailsModal] =
    useState(false);
  // const [profileModalOpen, setProfileModalOpen] = useState(false); // Modal state
  // const [profileData, setProfileData] = useState({}); // Store profile data
  const [hoveredProfile, setHoveredProfile] = useState({
    isVisible: false,
    x: 0,
    y: 0,
    data: null,
  });


  const [deleteWarningModal, setDeleteWarningModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [gridApi, setGridApi] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const notifyError = () => toast.error("Employee failed to update");
  const notifyUpdated = () => toast.success("Employee Updated Successfully");
  const notifyDelete = () => toast.success("Employee Deleted Successfully");
  const [searchTerm, setSearchTerm] = useState("");
  const [skillsModalOpen, setSkillsModalOpen] = useState(false); // Modal state
  const [employeeSkills, setEmployeeSkills] = useState([]); // Store skills

  // Fetch skills for a specific employee


  // Open skills modal and fetch skills
    const openSkillsModal = (data) => {
    setEmployeeSkills(data.skills || []); // Set skills data
    setSingleEmployeeData(data); // Set employee data
    setSkillsModalOpen(true); // Open the modal
  };

  const handleProfileHover = (event, empId) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const employee = employeesList.find((emp) => emp.id === empId);
    if (employee) {
      setHoveredProfile({
        isVisible: true,
        x: rect.left,
        y: rect.top,
        data: {
          fullName: employee.fullName,
          designation: employee.designation,
          image: employee.profilePictureUrl || "default-image.jpg",
        },
      });
    }
  };
  const handleProfileLeave = () => {
    setHoveredProfile({ isVisible: false, x: 0, y: 0, data: null });
  };


 



  const closeSkillsModal = () => {
    setSkillsModalOpen(false);
    setSingleEmployeeData({});
  };

  const filteredSkills = employeeSkills.filter((skill) =>
    skill.skillName && skill.skillName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    setSelectedRows([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeEditEmployeeModel = () => {
    setEditEmployeeDetailsModal(false);
  };

  const noDataDisplay = () => (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <img
        className="noData-img"
        alt="NoData"
        src="https://img.freepik.com/free-vector/no-data-concept-illustration_114360-536.jpg?w=740&t=st=1685691455~exp=1685692055~hmac=e7fe93b465ad04cefb40b139444400f1cb0f9068a880f91999b843299068fdca"
      />

      <h3>No Records Found</h3>
    </div>
  );

  const deleteEmployee = async () => {
    try {
      setIsDeleting(true);
      const response = await deleteUser(selectedRows);
      if (response.status === 200) {
        setSelectedRows([]);
        notifyDelete();
        refreshEmployeesList();
        setDeleteWarningModal(false);
      }
      else{
         const data=await response.json();
         setErrorMessage(data.detail || "Failed to delete employee. Please try again.");

      }
    } catch (error) { }
    finally { setIsDeleting(false); }
  };



  const defaultColDef = useMemo(() => {
    return {
      cellStyle: { fontSize: "14px" },
    };
  }, []);

  const paginationPageSize = 20;

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const onSelectionChanged = () => {
    if (gridApi) {
      const selectedNodes = gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map((node) => node.data.id);
      setSelectedRows(selectedData);
    }
  };

  const columnDefs = [
    ...(canDelete
      ? [
          {
            headerName: "", // Empty header for checkbox column
            checkboxSelection: true, // Enable checkbox selection
            headerCheckboxSelection: true, // Show header checkbox to select all rows
            width: 20, // Set the width of the checkbox column
            resizable: false,
            pinned: "left",
            cellClass: "no-row-nav",
          },
        ]
      : []),
    ...(canEdit
      ? [
          {
            headerName: "",
            width: 50,
            pinned: "left",
            cellStyle: { paddingRight: 0 },
            cellClass: "no-row-nav",
            cellRenderer: (params) => (
              <>
                <RiPencilLine
                  id={params.data.id}
                  onClick={() => {
                    setSingleEmployeeData(params.data);
                    setEditEmployeeDetailsModal(true);
                  }}
                  style={{ fontSize: "20px", cursor: "pointer" }}
                />
              </>
            ),
          },
        ]
      : []),
    {
      headerName: "",
      width: 30,
      pinned: "left",
      cellStyle: { padding: 0 },
      cellClass: "no-row-nav",
      cellRenderer: (params) => (
        <>
          <TbBulb
            id={params.data.id}
            onClick={() => openSkillsModal(params.data)}
            style={{  fontSize: "25px",cursor: "pointer" }}
          />
        </>
      ),
    },
    {
      headerName: "EMP ID",
      field: "id",
      width: 150,
      sortable: true,
      pinned: "left",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "",
      width: 40,
      pinned: "left",
      cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" },
      cellClass: "no-row-nav",
      cellRenderer: (params) => (
        <div
          id={params.data.id}
          onClick={(e) => handleProfileHover(e, params.data.id)}
          onMouseLeave={handleProfileLeave}
          style={{ width: "38px", height: "38px", borderRadius: "50%", overflow: "hidden", flexShrink: 0, cursor: "pointer" }}
        >
          <img
            src={params.data.profilePictureUrl}
            alt="Profile"
            style={{ width: "38px", height: "38px", objectFit: "cover", objectPosition: "center", display: "block" }}
          />
        </div>
      ),
    },



    {
      headerName: "NAME",
      cellRenderer: (params) => {
        return <p>{params.data.fullName}</p>;
      },
      field: "fullName",
      pinned: "left",
      tooltipField: "fullName",
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },

    {
      headerName: "EMAIL",
      field: "email",
      width: 350,
      filter: true,
      floatingFilter: true,
      tooltipField: "email",
      suppressMenu: true
    },
    {
      headerName: "ROLE",
      field: "role",
      width: 130,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "LEAD",
      field: "leadName",
      width: 130,
      filter: true,
      floatingFilter: true,
      suppressMenu: true,
      cellRenderer: (params) => params.value || "-",
          cellStyle: (params) => ({
            textAlign: params.value ? "left" : "center"
          }),
    },
    {
      headerName: "DESIGNATION",
      field: "designation",
      width: 200,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "DEPARTMENT",
      field: "department",
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "QUALIFICATIONS",
      field: "qualifications",
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "JOINING DATE",
      field: "joiningDate",
      width: 180,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "TOTAL EXPERIENCE",
      width: 300,
      field: "totalExperience",
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "ORGANIZATION EXPERIENCE",
      field: "organizationExperience",
      width: 300,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "EMP STATUS",
      field: "employementStatus",
      width: 180,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "DOB",
      field: "dateOfBirth",
      width: 120,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "GENDER",
      field: "gender",
      width: 150,
      cellStyle: { display: "flex", justifyContent: "center" },
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "BLOOD GROUP",
      field: "bloodGroup",
      width: 180,
      cellStyle: { display: "flex", justifyContent: "center" },
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "MOBILE NO",
      field: "mobileNumber",
      width: 150,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "EMG CONTACT NAME",
      field: "emergencyContactName",
      width: 250,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },

    {
      headerName: "EMG CONTACT NUMBER",
      field: "emergencyContactNumber",
      width: 250,
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
    {
      headerName: "LOCATION",
      field: "address",
      filter: true,
      floatingFilter: true,
      suppressMenu: true
    },
  ];

  const renderTable = () => (
    <div
      className="ag-theme-alpine active-employees-grid-wrapper"
      style={{
        height: "78vh",
        fontSize: "14px",
        marginLeft: "20px",
        marginRight: "20px",
        fontFamily: "Arial, Helvetica, sans-serif",
        backgroundColor: "#FFFFFF",
      }}
    >
      <AgGridReact
        title="All Employees"
        columnDefs={columnDefs}
        rowData={employeesList}
        pagination={true}
        paginationPageSize={paginationPageSize}
        defaultColDef={defaultColDef}
        rowSelection="multiple"
        onGridReady={onGridReady}
        onSelectionChanged={onSelectionChanged}
        onRowClicked={handleRowClicked}
        suppressRowClickSelection="true"
        suppressCellFocus={true}
        enableCellTextSelection={true}
        rowStyle={{ cursor: "pointer" }}
        // suppressMenu={true}
      ></AgGridReact>
    </div>
  );

  const renderEmployeeTable = () => (
    <div className="table-container">
      {employeesList.length > 0 ? renderTable() : noDataDisplay()}
    </div>
  );

  const onClickRetry = () => refreshEmployeesList();

  const renderAllEmployeesPage = () => {
    switch (apiStatus) {
      case apiStatusConstants.success:
        return renderEmployeeTable();
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={onClickRetry} />;
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      default:
        return null;
    }
  };

  return (
    <>
      <div>
        {canDelete && selectedRows.length > 0 && (
          <div className="d-flex align-items-center deleteEmployeesContainer">
            <p className="pt-3">{selectedRows.length} {selectedRows.length === 1 ? "Employee" : "Employees"} Selected</p>
            <button className="deleteIcon" onClick={() => setDeleteWarningModal(true)}>
              <MdDeleteOutline />
            </button>
          </div>
        )}

        {renderAllEmployeesPage()}
      </div>
      <SlidingModal
        modalName={`Skills - ${singleEmployeeData.fullName}`}
        closeBtn={closeSkillsModal}
        isModalOpen={skillsModalOpen}
      >
        <div className="skills-modal-content">
          <input
            type="text"
            placeholder="Search skills..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.trimStart())}
            className="skills-search-bar"
          />

          <ul className="skills-list-container">
            {(filteredSkills.length === 0) ? (
              <li>No skills available</li>
            ) : (
              filteredSkills.map((skill, index) => {
                const rating = parseInt(skill.skillRating) * 10;
                const ratingColor = rating > 30 ? "bg-success" : "bg-danger";
                return (
                  <div key={index}>
                    <li className="skills-list-item">
                      <div className="d-flex justify-content-between">
                        <p>{skill.skillName}</p>
                        <p>{rating} %</p>
                      </div>
                      <div className="progress">
                        <div
                          className={`progress-bar ${ratingColor}`}
                          role="progressbar"
                          style={{ width: `${rating}%` }}
                          aria-valuenow={rating}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </li>
                  </div>
                );
              })
            )}
          </ul>
        </div>
      </SlidingModal>

      {hoveredProfile.isVisible && hoveredProfile.data && (
        <div
          className="profile-hover-box"
          style={{
            top: hoveredProfile.y + 60, // Adjust position slightly below the profile box
            left: hoveredProfile.x,
          }}
        >
          <img
            src={hoveredProfile.data.image}
            alt="Employee"
            className="hover-profile-image"
          />
         <h3 className="hover-profile-name">{hoveredProfile.data.fullName}</h3>
          <p className="hover-profile-designation">
            {hoveredProfile.data.designation}
          </p>
         </div>
      )}

    {/* Delete Confirmation Modal */}
      <div className="no-modal-mb">
        <PopupModal
          showModal={deleteWarningModal}
          modalName="Confirm Delete"
          closeBtn={() => setDeleteWarningModal(false)}
          marginBottom="0px"
        >
          <div>
            <p>Are you sure you want to delete the selected {selectedRows.length === 1 ? "employee" : "employees"}?</p>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                marginTop: "15px",
              }}
            >
               {errorMessage && (
                              <ErrorText className="mt-3">*{errorMessage}</ErrorText>
                            )}
              <SecondaryButton onClick={() => setDeleteWarningModal(false)}>
                No
              </SecondaryButton>
              <PrimaryButton onClick={deleteEmployee} disabled={isDeleting}>
                {isDeleting ? "Deleting..." : "Yes"}
              </PrimaryButton>
            </div>
          </div>
        </PopupModal>
      </div>



      <SlidingModal
        modalName="Edit Employee"
        closeBtn={closeEditEmployeeModel}
        isModalOpen={editEmployeeDetailsModal}
      >
        <EditEmployeeModal
          fetchEmployees={refreshEmployeesList}
          notifyUpdated={notifyUpdated}
          notifyError={notifyError}
          singleEmployeeData={singleEmployeeData}
          closeEditEmployeeModel={closeEditEmployeeModel}
          leads={leads}
        />
      </SlidingModal>

    </>
  );
};

export default ActiveEmployeeTable;
